var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChipButton',{attrs:{"active":_vm.hasActiveFilter}},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.openFilterBarMenu.apply(null, arguments)}}},[_c('FontAwesomeIcon',{attrs:{"icon":"filter"}}),_c('span',{staticClass:"show-sm-up"},[_vm._v(" "+_vm._s(_vm.$t('WEBAPP_FILTERS')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }